import { fieldFromXml } from "../helpers";

const SUFFIXES = [" m", " km/h", " °", " V", " °C", " km"];

const SECTIONS: { title: string; icon: string; tags: [string, string][] }[] = [
  {
    title: "Identificación", icon: "🔖",
    tags: [
      ["Asset", "asset"], ["Serial", "serialNumber"],
      ["IMEI", "imei"], ["Unit ID", "unitId"],
      ["Placa", "plate"], ["VIN", "vin"],
      ["Driver ID", "driverId"],
    ],
  },
  {
    title: "Fecha / Hora", icon: "🕐",
    tags: [
      ["Fecha GPS", "date"],
      ["Fecha Servidor", "serverDate"],
      ["Timestamp", "timestamp"],
    ],
  },
  {
    title: "Ubicación", icon: "📍",
    tags: [
      ["Latitud", "latitude"], ["Longitud", "longitude"],
      ["Altitud", "altitude"], ["Velocidad", "speed"],
      ["Dirección", "direction"], ["Heading", "heading"],
      ["Odómetro", "odometer"], ["Satélites", "satellites"],
      ["HDOP", "hdop"], ["Dirección", "address"],
      ["GeoFence", "geoFence"],
    ],
  },
  {
    title: "Estado / IO", icon: "⚡",
    tags: [
      ["Ignición", "ignition"], ["Evento", "event"],
      ["Tipo Evento", "eventType"], ["Código Evento", "eventCode"],
      ["Alarma", "alarm"], ["Razón", "reason"],
      ["Input Digital", "digitalInput"], ["Output Digital", "digitalOutput"],
      ["Input Análogo", "analogInput"],
    ],
  },
  {
    title: "Energía / Sensores", icon: "🔋",
    tags: [
      ["Voltaje Ext.", "mainPower"], ["Batería Int.", "internalBattery"],
      ["Batería", "batteryVoltage"], ["Temperatura", "temperature"],
      ["Combustible", "fuelLevel"], ["RSSI", "rssi"],
    ],
  },
];

const UNIT_MAP: Record<string, string> = {
  altitude: " m", speed: " km/h", direction: "°", heading: "°",
  odometer: " km", mainPower: " V", internalBattery: " V",
  batteryVoltage: " V", temperature: " °C",
};

function formatDateField(value: string): string {
  return value.replace("T", " ").replace("Z", " UTC");
}

function buildRows(xml: string, tags: [string, string][]): [string, string][] {
  return tags.map(([label, tag]) => {
    let val = fieldFromXml(xml, tag);
    if (tag === "date" || tag === "serverDate") val = formatDateField(val);
    if (UNIT_MAP[tag] && val !== "—") val += UNIT_MAP[tag];
    return [label, val];
  });
}

function isEmptyValue(v: string): boolean {
  if (v === "—") return true;
  return SUFFIXES.some((s) => v === `— ${s.trim()}` || v === `—${s}`);
}

export function XmlSummary({ xml, isDarkMode }: { xml: string; isDarkMode: boolean }) {
  return (
    <div className="overflow-auto flex-1 px-0.5">
      {SECTIONS.map((sec) => {
        const rows = buildRows(xml, sec.tags);
        const visible = rows.filter(([, v]) => !isEmptyValue(v));
        if (visible.length === 0) return null;
        return (
          <div key={sec.title} className="mb-3">
            <div className={`text-[10px] font-bold uppercase tracking-wide mb-1.5 flex items-center gap-1 border-b pb-1 ${
              isDarkMode ? "text-gray-400 border-dark-border" : "text-slate-500 border-slate-200"
            }`}>
              <span>{sec.icon}</span> {sec.title}
            </div>
            <div className="flex flex-col gap-1">
              {visible.map(([l, v]) => (
                <div key={l} className="flex justify-between items-baseline gap-2">
                  <span className={`text-[11px] shrink-0 ${isDarkMode ? "text-gray-400" : "text-slate-500"}`}>{l}</span>
                  <span className={`text-xs font-mono text-right break-all ${isDarkMode ? "text-gray-200" : "text-slate-800"}`}>{v}</span>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
